import type { Dictionary } from '../types';

export const ru: Dictionary = {
  doc_title: 'BITSECURE — Аудит информационной безопасности и пентест для бизнеса',

  nav_services: 'Услуги',
  nav_why: 'Почему мы',
  nav_process: 'Как работаем',
  nav_contact: 'Контакты',
  nav_cta: 'Получить консультацию',

  hero_h1: 'Защита бизнеса, которой можно доверять',
  hero_lead:
    'BITSECURE проводит независимый аудит и тестирование на проникновение, выявляя слабые места в ваших системах до того, как ими воспользуются. Понятные отчёты, конкретные рекомендации, строгая конфиденциальность.',
  hero_cta1: 'Получить консультацию →',
  hero_cta2: 'Наши услуги',
  hero_note: 'Работаем по договору и NDA · первичная консультация бесплатна',

  chip1_t: 'Аудит пройден',
  chip1_s: '0 критичных',
  chip2_t: 'NDA',
  chip2_s: 'конфиденциально',
  chip3_t: 'Отчёт + план',
  chip3_s: 'понятные шаги',

  trust1_l: 'проведённых тестирований',
  trust2_l: 'отраслей и компаний',
  trust3_l: 'соблюдение NDA',
  trust4_l: 'поддержка после аудита',

  svc_h2: 'Комплексная оценка защищённости',
  svc_p:
    'Полный спектр услуг — от точечного аудита приложения до масштабной имитации целевой атаки на компанию.',

  why_h2: 'Партнёр, а не подрядчик',
  why_p: 'Мы отвечаем за результат: находим реальные риски и помогаем их закрыть.',

  proc_h2: 'Понятный процесс на каждом этапе',

  std_lab: 'Работаем по признанным <b>международным методологиям</b> тестирования',

  contact_h2: 'Обсудим безопасность вашего бизнеса',
  contact_p:
    'Свяжитесь с командой — оценим задачи, согласуем объём и сроки. Первичная консультация бесплатна.',

  foot_tagline:
    'Независимый аудит информационной безопасности и тестирование на проникновение для бизнеса.',
  foot_services: 'Услуги',
  foot_company: 'Компания',
  foot_connect: 'Связаться',
  foot_s1: 'Веб-приложения',
  foot_s2: 'Внешний периметр',
  foot_s3: 'Red Team',
  foot_s4: 'Аудит кода',
  foot_s5: 'Социальная инженерия',
  foot_rights: '© 2025 BITSECURE. Все права защищены.',
  foot_privacy: 'Политика конфиденциальности',
  foot_offer: 'Договор-оферта',

  pop_title: 'Связаться с нами',
  pop_sub: 'Выберите удобный канал — ответим быстро.',

  order: 'Заказать',

  form_title: 'Оставить заявку',
  form_sub: 'Заполните форму — ответим в течение дня.',
  f_company: 'Название компании',
  f_email: 'Адрес электронной почты',
  f_method: 'Предпочтительный способ связи',
  f_m_tg: 'Telegram',
  f_m_phone: 'Телефон',
  f_m_wa: 'WhatsApp',
  f_contact_tg: 'Имя пользователя в Telegram',
  f_contact_phone: 'Номер телефона',
  f_contact_wa: 'Номер WhatsApp',
  f_service: 'Интересующая услуга',
  f_comments: 'Дополнительные комментарии',
  f_submit: 'Отправить заявку',
  f_succ_t: 'Заявка отправлена!',
  f_succ_s: 'Спасибо! Мы свяжемся с вами в ближайшее время.',
  f_close: 'Закрыть',

  ch_phone_t: 'Телефон',
  ch_phone_s: 'по запросу',
  ch_wa_s: 'быстрый ответ',

  services: [
    ['Веб-приложения', 'Находим уязвимости в веб-приложениях по методологии OWASP — до того, как их обнаружат злоумышленники.'],
    ['Внешний периметр', 'Проверяем устойчивость внешней инфраструктуры к проникновению из интернета.'],
    ['Внутренняя сеть', 'Моделируем атаку изнутри: что сможет сделать злоумышленник, получивший доступ в сеть.'],
    ['Red Team', 'Полная имитация реальной целевой атаки — проверка готовности команды и процессов реагирования.'],
    ['Мобильные приложения', 'Аудит iOS и Android: хранение данных, бизнес-логика, защищённость API.'],
    ['Аудит исходного кода', 'Ищем уязвимости и ошибки на уровне кода — статический анализ и ручной разбор.'],
    ['Беспроводные сети', 'Тестирование Wi-Fi на перехват трафика и несанкционированный доступ.'],
    ['Социальная инженерия', 'Проверяем сотрудников на фишинг и манипуляции, находим слабые места в политиках.'],
    ['Консалтинг и процессы', 'Выстраиваем безопасные рабочие процессы и стратегию защиты данных.'],
  ],
  why: [
    ['01', 'Конфиденциальность', 'Строгое соблюдение NDA и защита данных клиента на всех этапах работы.'],
    ['02', 'Экспертные знания', 'Опытные специалисты применяют передовые методики и мышление реального атакующего.'],
    ['03', 'Практические рекомендации', 'Конкретные шаги по устранению — понятный план действий, а не абстрактный отчёт.'],
    ['04', 'Индивидуальный подход', 'Адаптируем сценарии под вашу инфраструктуру, риски и ресурсы.'],
  ],
  steps: [
    ['01', 'Анализ потребностей', 'Детально разбираем требования, активы и цели, чтобы выбрать верный подход.'],
    ['02', 'Разработка решений', 'Формируем индивидуальную стратегию и сценарии тестирования.'],
    ['03', 'Реализация и поддержка', 'Проводим работы и сопровождаем устранение найденных проблем.'],
    ['04', 'Обратная связь', 'Постоянно улучшаем услуги на основе результатов и потребностей клиента.'],
  ],
};
